import { all, takeLatest } from 'redux-saga/effects'
import store from '../../store'
import { actions } from './PurchaseOrders.slice'
import { paginate } from './PurchaseOrders.thunk'

function paginatePurchaseOrders () {
  store.dispatch(paginate() as any)
}

export default function * effects () {
  yield all([
    takeLatest(actions.replaceLimit, paginatePurchaseOrders),
    takeLatest(actions.replacePage, paginatePurchaseOrders),
    takeLatest(actions.replaceSearch, paginatePurchaseOrders)
  ])
}
